import React, { useState } from 'react';

const Select = ({ children, value, onValueChange }) => {
  const [open, setOpen] = useState(false);
  
  return (
    <div className="relative">
      {React.Children.map(children, child =>
        React.cloneElement(child, { open, setOpen, value, onValueChange })
      )}
    </div>
  );
};

const SelectTrigger = React.forwardRef(({ className = '', children, open, setOpen, ...props }, ref) => (
  <button
    ref={ref}
    className={`flex h-10 w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    onClick={() => setOpen(!open)}
    {...props}
  >
    {children}
  </button>
));
SelectTrigger.displayName = 'SelectTrigger';

const SelectValue = ({ placeholder, value }) => (
  <span className={value ? '' : 'text-gray-500'}>
    {value || placeholder}
  </span>
);

const SelectContent = React.forwardRef(({ className = '', children, open, setOpen, onValueChange, ...props }, ref) => {
  if (!open) return null;
  
  return (
    <>
      <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
      <div
        ref={ref}
        className={`absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md border bg-white text-gray-900 shadow-md ${className}`}
        {...props}
      >
        {React.Children.map(children, child =>
          React.cloneElement(child, { onValueChange, setOpen })
        )}
      </div>
    </>
  );
});
SelectContent.displayName = 'SelectContent';

const SelectItem = React.forwardRef(({ className = '', children, value, onValueChange, setOpen, ...props }, ref) => (
  <div
    ref={ref}
    className={`relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none hover:bg-gray-100 hover:text-gray-900 ${className}`}
    onClick={() => {
      onValueChange(value);
      setOpen(false);
    }}
    {...props}
  >
    {children}
  </div>
));
SelectItem.displayName = 'SelectItem';

export {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
};